import _ from 'lodash';
import { refDriverService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefDriver() {
    return {
        refDriverId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        programCount: 0
    };
}

export const refdrivers = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefDriver: getBlankRefDriver()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refDriverService.getByAccount(accountId)
                    .then(
                        refDrivers => {
                            commit(GET_ALL_SUCCESS, refDrivers);
                            resolve(refDrivers);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refDriverId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refDriverService.getById(refDriverId)
                    .then(
                        refDriver => {
                            commit(GET_BY_ID_SUCCESS, refDriver);
                            resolve(refDriver);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refDriver) {
            return refDriverService.add(refDriver);
        },
        [UPDATE]({ dispatch, commit }, refDriver) {
            return refDriverService.update(refDriver);
        },
        [DELETE]({ dispatch, commit }, refDriver) {
            return refDriverService.deleteRefDriver(refDriver);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refDrivers) {
            state.status = { loaded: true };
            state.items = refDrivers;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refDriver) {
            state.status = { loaded: true };
            state.currentRefDriver = refDriver;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefDriver = getBlankRefDriver();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefDriver = getBlankRefDriver();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefDriver, {
                [field]: value
            });
        },
    }
}
